import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createProductStockDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();

    //create user object
    details.uniqueId = uniqueId;
    details.ProductStockPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('ProductStock').doc(details.ProductID);
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getProductStockDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductStock').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getProductStockDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductStock').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getProductStockDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('ProductStock').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllProductStockDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductStock').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateProductStockDocument = async (product) => {
    const docRef = db.doc(`/ProductStock/${product.ProductID}`);
    return docRef.update(product);
}

export const checkIsStockOfProductExistsOrNot = async (ProductID) => {
    const snapshot = await db.collection('ProductStock').where("ProductID", "==", ProductID).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}